// What we say while nobody pays (Deuce, Oct 30, 2026): restaurants sign up at no cost and see their
// own data before any pricing. One place for these lines, so the page and the pitch match.
// No "free" here: diner copy never says it, and restaurant copy uses "no cost" until Deuce picks.

/** /restaurants, under the Sign up button. Short: the page has a word budget (test/restaurants.test.ts). */
export const RESTAURANT_NO_COST = 'No cost to sign up.';

/** The last line of every restaurant message the app writes (the admin pitch). */
export const RESTAURANT_NO_COST_LINE = "Sign up now at no cost, and we'll send you your own numbers before any pricing.";
